<app-section-free-mock [title]="'Dashboard'"></app-section-free-mock>

<app-section-study-materials></app-section-study-materials>


<app-section-progress-report></app-section-progress-report>

<!-- 
<app-plans></app-plans> -->